// ============================================================
// 工作台数据 Vuex 模块
// 按角色维度存储工作台数据
// ============================================================
import { unifiedRoles } from '@/constants/ecosystemData';

export default {
  namespaced: true,
  state: {
    currentRole: 'partner',
    roles: unifiedRoles
  },
  getters: {
    currentRoleData: (state) => {
      return state.roles[state.currentRole] || state.roles.partner;
    },
    roleList: (state, getters, rootState) => {
      const user = rootState.user.currentUser;
      if (!user) return [];

      // 服务商系统暂未开放；其余三个系统根据 currentUser 字段判断显隐
      const visible = {
        partner: user.companyId !== '999999999999' && user.web2,
        solution: user.schemeCertificationStatus === 'Completed',
        supply: user.supplierCertificationStatus === 'Completed'
      };

      return Object.entries(unifiedRoles)
        .filter(([key]) => key !== 'service' && visible[key])
        .map(([key, r]) => ({ key, ...r }));
    }
  },
  mutations: {
    SET_CURRENT_ROLE(state, role) {
      if (state.roles[role]) {
        state.currentRole = role;
      }
    }
  },
  actions: {
    switchRole({ commit }, role) {
      commit('SET_CURRENT_ROLE', role);
    }
  }
};
